import React from 'react';
import { Button, styled } from '@mui/material';
import {
  CustomisedButton,
  CustomisedIconButton,
  CustomisedSaveButton,
  CustomisedUploadButton,
  CustomisedDeleteButton,
  CustomisedSettingsDeleteButton,
  CustomisedSettingsLightModeDeleteButton,
  CustomisedLightModeDeleteButton,
  CustomisedLoadingIconButton,
} from './style';
import { Colors, DarkmodeColors } from 'app/constants/color';

const StyledButton = props => {
  const CustomisedIdentityButton = styled(Button)({
    height: '60px',
    width: '100%',
    backgroundColor: 'transparent',
    textTransform: 'none',
    borderRadius: 0,
  });

  const CustomisedIdentitySmallButton = styled(Button)({
    height: '30px',
    width: 'max-content',
    backgroundColor: 'transparent',
    textTransform: 'none',
  });

  const buttonComponents = {
    BankID: CustomisedButton,
    Arrowback: CustomisedIconButton,
    Save: CustomisedSaveButton,
    Upload: CustomisedUploadButton,
    Delete: CustomisedDeleteButton,
    'Settings-Delete': CustomisedSettingsDeleteButton,
    'Settings-Darkmode-Delete': CustomisedSettingsLightModeDeleteButton,
    'Edit-User-Delete': CustomisedLightModeDeleteButton,
    Identity2: CustomisedIdentityButton,
    IdentitySmall: CustomisedIdentitySmallButton,
    IconButton: CustomisedIconButton,
    LoadingButton: CustomisedLoadingIconButton,
  };

  const SpecificButton = buttonComponents[props.name] || Button;

  return <SpecificButton {...props} sx={getSxProps(props)} />;
};

const getSxProps = props => {
  if (props.name === 'Save') {
    return {
      background: Colors.primary,
      color: 'white',
      ':hover': {
        background: DarkmodeColors.menuIcon,
        cursor: 'pointer',
      },
    };
  }
  return props.sx || {};
};

export default StyledButton;
